import React, { useContext } from "react";
import Slider from "react-slick";
import { PRODUCT_TYPE_VOUCHER_MANAGER } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import PlayIcon from "@components/Icons/PlayIcon";
import TrailerButton from "@components/TrailerButton";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const SlickSlider = Slider.default || Slider;

const FeatureFilm = () => {
    const { featureFilm, isLoadingFeatureFilms, productTypeId } = useContext(ApplicationContext);
    const isVoucherManager = productTypeId === PRODUCT_TYPE_VOUCHER_MANAGER;

    const settings = {
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: true,
        speed: 600,
        initialSlide: 0,
        autoplaySpeed: 7000,
        cssEase: "ease-in-out",
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const renderImage = (film) => (
        <picture>
            <source media="(min-width: 1025px)" srcSet={film.image_url} />
            <img className="feature-film__image" src={film.mobile_image_url} alt={film.description} />
        </picture>
    );

    const renderFilmContent = (film, i) => {
        const suppressLink = isVoucherManager && film.feature_film_flag;

        return (
            <div key={`${film.id}-${i}`} className="feature-film__wrapper">
                {suppressLink ? (
                    renderImage(film)
                ) : (
                    <a className="feature-film__link" href={film.feature_url} target="_blank" rel="noreferrer">
                        {renderImage(film)}
                    </a>
                )}
                {film.trailer_url && (
                    <TrailerButton
                        extraClass="trailer-button trailer-button--official-trailer"
                        type="youtube"
                        trailerLink={film.trailer_url}
                    >
                        <PlayIcon className="trailer-button__svg" />
                        <span className="trailer-button__button-text">Official Trailer</span>
                    </TrailerButton>
                )}
            </div>
        );
    };

    if (isLoadingFeatureFilms) return <Loader />;
    if (!featureFilm || featureFilm.length === 0) return null;

    if (featureFilm.length === 1) {
        return (
            <div className="feature-film__container">
                <div className="feature-film__list">
                    {renderFilmContent(featureFilm[0], 0)}
                </div>
            </div>
        );
    }

    return (
        <div className="feature-film__container">
            <div className="feature-film__list">
                <SlickSlider {...settings}>
                    {featureFilm.map((film, i) => renderFilmContent(film, i))}
                </SlickSlider>
            </div>
        </div>
    );
};

export default FeatureFilm;
